interface V3IconArticleProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
    size?: string;
}

export const V3IconArticle = ({ stroke = "#ABB0BA", size = "16" }: V3IconArticleProps) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 8H6M7 5H6M10 11H6" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <rect x="2.5" y="1" width="11" height="14" rx="1.5" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
